module.exports = __webpack_public_path__ + "static/media/mod-taxi.c6454bb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/mod-taxi.jpg
// module id = 340
// module chunks = 0